import { FC, ReactNode } from 'react'
import { IconButton } from '@mui/material'
import toast from 'react-hot-toast'

interface Props {
  text?: string
  description?: ReactNode
  type?: string
}

const HotToast: FC<Props> = ({ text, description }) => {
  return (
    <div
      className="hot-toast__row"
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '16px'
      }}
    >
      <div
        className="hot-toast__text-wrapper"
        style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0, gap: '8px' }}
      >
        {text && (
          <p className="hot-toast__text" style={{ margin: 0 }}>
            {text}
          </p>
        )}
        {description && (
          <p className="hot-toast__description" style={{ margin: 0 }}>
            {description}
          </p>
        )}
      </div>

      <IconButton
        className="hot-toast__close"
        disableRipple
        onClick={() => toast.dismiss()}
        sx={{
          flexShrink: 0,
          alignSelf: 'center',
          padding: '4px !important',
          borderRadius: '50% !important',
          transition: 'background-color 0.15s ease',
          '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.16) !important' }
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: 20, height: 20, minWidth: 20, minHeight: 20, flexShrink: 0 }}
        >
          <path
            d="M5 15L15 5M5 5L15 15"
            stroke="#F4EFF4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconButton>
    </div>
  )
}

export default HotToast
